import { styled as s } from "@mui/material";
import a from "../assets/icon-goto-battle-pass.png.js";
import i from "./ApeironGotoRoundButton.js";
import { useTranslation as p } from "react-i18next";
import { jsx as m } from "react/jsx-runtime";
const u = s(i)`
  .Custom-Container {
    background-color: unset;
    background: url('') padding-box,
      linear-gradient(to right, #feecd1, #dba777) border-box;

    .Custom-Link {
      .Custom-Icon-Text {
        ${(t) => t.theme.breakpoints.up("res768")} {
          gap: 14px;
        }
        ${(t) => t.theme.breakpoints.down("res768")} {
          gap: 3px;
        }

        .Custom-Icon {
          ${(t) => t.theme.breakpoints.up("res768")} {
            margin-left: -7px;
            width: 80px;
          }
          ${(t) => t.theme.breakpoints.down("res768")} {
            margin-left: -14px;
            width: 70px;
          }
        }

        strong {
          text-decoration: underline;
        }
      }
    }
  }
`, b = (t) => {
  const {
    className: o,
    url: e,
    target: r
  } = t, {
    t: n
  } = p();
  return /* @__PURE__ */ m(u, {
    className: o,
    icon: a.toString(),
    url: e,
    target: r,
    text: n("goto.battle_pass_event")
  });
};
export {
  b as default
};
//# sourceMappingURL=GotoBattlePassEvent.js.map
